/**
 * The units a metric can be recorded in: one per metric_type the backend
 * stores, with the label shown wherever the unit is. A metric's unit is
 * fixed once it is created.
 */
export const METRIC_UNITS = [
  { value: 'Count', metricType: 'COUNT', label: 'Count (whole numbers)' },
  { value: 'Decimal', metricType: 'DECIMAL', label: 'Number with decimals' },
  { value: 'Currency', metricType: 'CURRENCY', label: 'Currency ($)' },
  { value: 'Percentage', metricType: 'PERCENTAGE', label: 'Percentage (%)' },
];

export const metricUnitLabel = (unit) =>
  METRIC_UNITS.find((metricUnit) => metricUnit.value === unit)?.label ?? unit;
